import type { LineItemRow } from './desktop-api';

export type LineItemCell = 'description' | 'quantity' | 'unitPrice' | 'amount';

export type LineItemEvidenceTarget = {
  pageNumber: number;
  lineIndexes: number[];
  cellSpecific: boolean;
};

/**
 * The exact printed cell an operator entered.
 *
 * A row-level citation is deliberately not substituted when an older or
 * ungrounded row has no cell evidence. It can still be shown by an explicit
 * row-evidence affordance, but focusing a number must not make the description
 * look like proof of that number.
 */
export const lineItemEvidenceForCell = (
  row: LineItemRow,
  cell: LineItemCell,
): LineItemEvidenceTarget => {
  if (!row.cellEvidence)
    return {
      pageNumber: row.pageNumber,
      lineIndexes: [],
      cellSpecific: false,
    };

  const lineIndexes = {
    description: row.cellEvidence.descriptionLineIndexes,
    quantity: row.cellEvidence.quantityLineIndexes,
    unitPrice: row.cellEvidence.unitPriceLineIndexes,
    amount: row.cellEvidence.amountLineIndexes,
  }[cell];
  return {
    pageNumber: row.cellEvidence.pageNumber,
    lineIndexes,
    cellSpecific: true,
  };
};
